import { Tooltip } from 'react-bootstrap';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import './CustomTooltip.css';

function CustomTooltip({txtClass, cstStyle, children}) {
  return (
    <OverlayTrigger
      placement="bottom"
      overlay={<Tooltip id="custom-tooltip" className='custom-tooltip'>{children}</Tooltip>}
    >
      {({ ref, ...triggerHandler }) => (
        <div
          {...triggerHandler}
          className={txtClass}
          style={cstStyle}
          ref={ref}
        >
          {children}
        </div>
      )}
    </OverlayTrigger>
  );
}

export default CustomTooltip;